// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1fsVQ","label":"Labeled_label__2giJm","divider":"Labeled_divider__3xMAx"};